var map = {
	"./_lift.svg": "e5f9",
	"./deviceMoving.svg": "5d91",
	"./deviceOffline.svg": "dc58",
	"./deviceOnline.svg": "0cec",
	"./deviceStopped.svg": "5fb9",
	"./deviceUnknown.svg": "d356",
	"./geofenceEnter.svg": "92fd",
	"./geofenceExit.svg": "3c7b",
	"./ignitionOff.svg": "0733",
	"./ignitionOn.svg": "682a",
	"./lift.svg": "68d9",
	"./maintenance.svg": "4978",
	"./overSpeed.svg": "ee06"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2b0b";